import fineSlice from "./fineSlice";
const fineActions = fineSlice.actions;
export const {
  setCurrentStep,
  setFineType,
  setInfringement,
  setAccount,
  setInfringementToken,
  setSearchBy,
  setSearchedID,
  setIDFines,
} = fineActions;
